<template>
  <div
    id="main-menu-bar"
    class="text-center main-menu-bar"
    v-bind:class="{ main_open: abrir }"
  >
    <div class="cont-frist-icon mt-0 mb-0 d-none d-lg-block">
      <!--span class="icon-logovp"></span-->
      <router-link to="/on-boarding">
        <img v-if="abrir" src="@/assets/images/icons/logovp3_LW40.svg" />
        <img
          v-else
          style="align: left"
          src="@/assets/images/icons/logovp3_40x40.svg"
        />
      </router-link>
    </div>
    <!-- Propinas -->
    <div class="cont-buttons d-flex flex-lg-column justify-content-around">
      <div v-if="user.core_role_id > 10 && user.core_role_id < 17">
        <div v-if="abrir">
          <router-link
            to="/tipshiftReport"
            class="menu-button"
            v-if="
              user.core_role_code == 'manager' ||
              user.core_role_code == 'supervisor-bodegas'
            "
          >
            <span class="icon icon-users mr-4"></span>
            <p class="mb-0 ml-4 d-none d-lg-block">Reporte de turnos</p>
          </router-link>
        </div>
        <div v-else tooltip="Reporte de turnos" flow="right">
          <router-link
            to="/tipshiftReport"
            class="menu-button"
            v-if="
              user.core_role_code == 'manager' ||
              user.core_role_code == 'supervisor-bodegas'
            "
          >
            <span class="icon icon-users"></span>
          </router-link>
        </div>

        <div v-if="user.core_role_code == 'nomina'">
          <div v-if="abrir">
            <router-link
              to="#"
              class="menu-button btn-group"
              id="tooltip-target-reports"
            >
              <span class="icon icon-download mr-4"></span>
              <p class="mb-0 ml-4 d-none d-lg-block">Reportes</p>
            </router-link>
          </div>
          <div v-else>
            <router-link to="#" class="menu-button" id="tooltip-target-reports">
              <span class="icon icon-download"></span>
            </router-link>
          </div>
          <b-tooltip
            :custom-class="abrir ? null : 'my-tooltip'"
            variant="light"
            placement="right"
            target="tooltip-target-reports"
            triggers="hover"
          >
            <b-button-group vertical size="lg">
              <b-button class="button-tooltip" to="generalsiesareport">
                Todos los reportes
              </b-button>
              <b-button class="button-tooltip" to="habilitar-reportes-de-turno">
                Habilitación reportes de turnos
              </b-button>
            </b-button-group>
          </b-tooltip>
        </div>

        <div v-if="user.core_role_code == 'tesoreria'">
          <div v-if="abrir">
            <router-link
              to="/tipsfileUpload"
              class="menu-button"
              v-if="user.core_role_code == 'tesoreria'"
            >
              <span class="icon icon-upload"></span>
              <p class="mb-0 ml-4 d-none d-lg-block">Carga de archivos</p>
            </router-link>
          </div>
          <div v-else tooltip="Carga de archivos" flow="right">
            <router-link
              to="/tipsfileUpload"
              class="menu-button"
              v-if="user.core_role_code == 'tesoreria'"
            >
              <span class="icon icon-upload"></span>
            </router-link>
          </div>
        </div>
        <!--div  tooltip="Novedades de nomina" flow="right">
          <router-link to="/novelties" class="menu-button" v-if="user.core_role_code == 'jefe-zona'">
            <span class="icon icon-spinner9"></span>
            
          </router-link>
        </div-->

        <div v-if="abrir">
          <router-link
            to="/novelties"
            class="menu-button"
            v-if="user.core_role_code == 'jefe-zona'"
          >
            <span class="icon icon-spinner9 mr-4"></span>
            <p class="mb-0 ml-4 d-none d-lg-block">Novedades de nómina</p>
          </router-link>
        </div>
        <div v-else tooltip="Novedades de nómina" flow="right">
          <router-link
            to="/novelties"
            class="menu-button"
            v-if="user.core_role_code == 'jefe-zona'"
          >
            <span class="icon icon-spinner9"></span>
          </router-link>
        </div>

        <div v-if="abrir">
          <router-link
            to="/reporttips"
            class="menu-button"
            v-if="user.core_role_code == 'jefe-zona'"
          >
            <span class="icon icon-newspaper mr-4"></span>
            <p class="mb-0 ml-4 d-none d-lg-block">Consulta de reportes</p>
          </router-link>
        </div>
        <div v-else tooltip="Consulta de reportes" flow="right">
          <router-link
            to="/reporttips"
            class="menu-button"
            v-if="user.core_role_code == 'jefe-zona'"
          >
            <span class="icon icon-newspaper"></span>
          </router-link>
        </div>

        <!--div tooltip="Consulta de reportes" flow="right">
          <router-link to="/reporttips" class="menu-button" v-if="user.core_role_code == 'jefe-zona'">
            <span class="icon icon-newspaper"></span>
          
          </router-link>
        </div-->

        <!--<div>
          <router-link to="/tipshiftReport" class="menu-button" v-if="user.core_role_id == 14">
            <span class="icon icon-download"></span>
            <p class="mb-0 d-none d-lg-block">Reportes</p>
          </router-link>
        </div>-->

        <div v-if="abrir">
          <router-link
            to="/tipsreporthistory"
            class="menu-button"
            v-if="
              user.core_role_code == 'manager' ||
              user.core_role_code == 'supervisor-bodegas'
            "
          >
            <span class="icon icon-history mr-4"></span>
            <p class="mb-0 ml-4 d-none d-lg-block">Historial de reportes</p>
          </router-link>
        </div>
        <div v-else tooltip="Historial de reportes" flow="right">
          <router-link
            to="/tipsreporthistory"
            class="menu-button"
            v-if="
              user.core_role_code == 'manager' ||
              user.core_role_code == 'supervisor-bodegas'
            "
          >
            <span class="icon icon-history"></span>
          </router-link>
        </div>

        <div v-if="abrir">
          <router-link
            to="/pointsale"
            class="menu-button"
            v-if="user.core_role_code == 'supervisor-bodegas'"
          >
            <span class="icon icon-office mr-4"></span>
            <p class="mb-0 ml-4 d-none d-lg-block">Puntos de ventas</p>
          </router-link>
        </div>
        <div v-else tooltip="Puntos de ventas" flow="right">
          <router-link
            to="/pointsale"
            class="menu-button"
            v-if="user.core_role_code == 'supervisor-bodegas'"
          >
            <span class="icon icon-office"></span>
          </router-link>
        </div>

        <div v-if="abrir">
          <router-link
            to="/tipsemployee"
            class="menu-button"
            v-if="
              user.core_role_code == 'manager' ||
              user.core_role_code == 'jefe-zona' ||
              user.core_role_code == 'supervisor-bodegas' ||
              user.core_role_code == 'trabajador'
            "
          >
            <span class="icon icon-money mr-4"></span>
            <p class="mb-0 ml-4 d-none d-lg-block">Mis propinas</p>
          </router-link>
        </div>
        <div v-else tooltip="Mis propinas" flow="right">
          <router-link
            to="/tipsemployee"
            class="menu-button"
            v-if="
              user.core_role_code == 'manager' ||
              user.core_role_code == 'jefe-zona' ||
              user.core_role_code == 'supervisor-bodegas' ||
              user.core_role_code == 'trabajador'
            "
          >
            <span class="icon icon-money"></span>
          </router-link>
        </div>

        <div v-if="user.core_role_code == 'nomina'">
          <div v-if="abrir">
            <router-link
              to="/reporttips"
              class="menu-button"
              v-if="user.core_role_code == 'nomina'"
            >
              <span class="icon icon-money mr-4"></span>
              <p class="mb-0 ml-4 d-none d-lg-block">Consulta de propinas</p>
            </router-link>
          </div>
          <div v-else tooltip="Consulta de propinas" flow="right">
            <router-link
              to="/reporttips"
              class="menu-button"
              v-if="user.core_role_code == 'nomina'"
            >
              <span class="icon icon-money"></span>
            </router-link>
          </div>
        </div>

        <div v-if="user.core_role_code == 'nomina'">
          <div v-if="abrir">
            <router-link
              to="/allsettings"
              class="menu-button"
              v-if="user.core_role_code == 'nomina'"
            >
              <span class="icon icon-pencil mr-4"></span>
              <p class="mb-0 ml-4 d-none d-lg-block">Ajuste de la plataforma</p>
            </router-link>
          </div>
          <div v-else tooltip="Ajuste de la plataforma" flow="right">
            <router-link
              to="/allsettings"
              class="menu-button"
              v-if="user.core_role_code == 'nomina'"
            >
              <span class="icon icon-pencil"></span>
            </router-link>
          </div>
        </div>

        <!--router-link to="/help" class="menu-button-help" tooltip="Ayuda" flow="right">
          <span class="icon icon-circle-help"></span>
       
        </router-link-->
        <div v-if="abrir">
          <router-link to="/help" class="menu-button help">
            <span class="icon icon-circle-help"></span>
            <p class="mb-0 d-none d-lg-block">Ayuda</p>
          </router-link>
        </div>
        <div v-else tooltip="Ayuda" flow="right">
          <router-link to="/help" class="menu-button help">
            <span class="icon icon-circle-help"></span>
          </router-link>
        </div>
      </div>

      <!-- LEGAL LABOR -->

      <div v-if="user.core_role_id > 20 && user.core_role_id < 23">
        <div v-if="abrir">
          <router-link
            to="/legal/process"
            class="menu-button labor"
            v-if="
              user.core_role_code == 'user-litigios' ||
              user.core_role_code == 'admin-litigios'
            "
          >
            <img
              src="@/assets/images/icons/icon-document-download.svg"
              class="icon mr-4"
            />
            <p v-if="abrir" class="mb-0 ml-4 d-none d-lg-block">Procesos</p>
          </router-link>
        </div>
        <div v-else tooltip="Procesos" flow="right">
          <router-link
            to="/legal/process"
            class="menu-button labor"
            v-if="
              user.core_role_code == 'user-litigios' ||
              user.core_role_code == 'admin-litigios'
            "
          >
            <img
              src="@/assets/images/icons/icon-document-download.svg"
              class="icon mr-4"
            />
          </router-link>
        </div>
        <div v-if="abrir">
          <router-link
            to="/legal/indicators"
            class="menu-button labor"
            v-if="
              user.core_role_code == 'user-litigios' ||
              user.core_role_code == 'admin-litigios'
            "
          >
            <img
              src="@/assets/images/icons/icon-chart-bar.svg"
              class="icon mr-4"
            />
            <p v-if="abrir" class="mb-0 ml-4 d-none d-lg-block">Indicadores</p>
          </router-link>
        </div>
        <div v-else tooltip="Indicadores" flow="right">
          <router-link
            to="/legal/indicators"
            class="menu-button labor"
            v-if="
              user.core_role_code == 'user-litigios' ||
              user.core_role_code == 'admin-litigios'
            "
          >
            <img
              src="@/assets/images/icons/icon-chart-bar.svg"
              class="icon mr-4"
            />
          </router-link>
        </div>
        <div v-if="abrir">
          <router-link
            to="/legal/help"
            class="menu-button labor"
            v-if="
              user.core_role_code == 'user-litigios' ||
              user.core_role_code == 'admin-litigios'
            "
          >
            <img src="@/assets/images/icons/icon-help.svg" class="icon mr-4" />
            <p v-if="abrir" class="mb-0 ml-4 d-none d-lg-block">Ayuda</p>
          </router-link>
        </div>
        <div v-else tooltip="Ayuda" flow="right">
          <router-link
            to="/legal/help"
            class="menu-button labor"
            v-if="
              user.core_role_code == 'user-litigios' ||
              user.core_role_code == 'admin-litigios'
            "
          >
            <img src="@/assets/images/icons/icon-help.svg" class="icon mr-4" />
          </router-link>
        </div>
      </div>

      <!-- HEALTH TRACKER -->
      <!-- core_role_code: "oh-specialist" -->
      <div
        v-if="
          (user.core_role_id > 16 && user.core_role_id < 21) ||
          user.core_role_code == 'business-partner'
        "
      >
        <template>
          <div>
            <ul class="menu">
              <div v-if="user.core_role_id == 17 || user.core_role_id == 18">
                <div v-if="abrir">
                  <router-link
                    :to="'/sve/null/null'"
                    class="menu-button color-azul"
                  >
                    <img
                      class="img-icon"
                      src="@/assets/images/icons/notepad.svg"
                    />
                    <p class="mb-0 ml-4 d-none d-lg-block">SVE</p>
                  </router-link>
                </div>
                <div v-else tooltip="SVE" flow="right">
                  <router-link
                    :to="'/sve/null/null'"
                    class="menu-button color-azul"
                  >
                    <img
                      class="icon mx-auto"
                      src="@/assets/images/icons/notepad.svg"
                    />
                  </router-link>
                </div>
              </div>

              <div v-if="abrir">
                <router-link to="/employee" class="menu-button color-azul">
                  <img
                    class="img-icon"
                    src="@/assets/images/icons/medic-concepts.svg"
                  />
                  <p class="mb-0 ml-4">Conceptos médicos</p>
                </router-link>
              </div>
              <div v-else tooltip="Conceptos médicos" flow="right">
                <router-link to="/employee" class="menu-button color-azul">
                  <img
                    class="icon mx-auto"
                    src="@/assets/images/icons/medic-concepts.svg"
                  />
                </router-link>
              </div>
              <div v-if="user.core_role_id == 18 || user.core_role_id == 17">
                <div
                  v-if="abrir"
                  :class="[{ 'active item-arrow': hasSubMenu }]"
                  @mouseover="showSubMenu = true"
                  @mouseleave="showSubMenu = false"
                  style="position: relative"
                >
                  <router-link
                    to="/gestion-de-la-informacion"
                    class="menu-button color-azul"
                    @mouseover="showSubMenu = true"
                    @mouseleave="showSubMenu = false"
                  >
                    <img
                      class="img-icon"
                      src="@/assets/images/icons/edit.svg"
                    />
                    <p class="mb-0 ml-4 d-none d-lg-block">
                      Gestión de la Info.
                    </p>
                  </router-link>
                </div>
                <div v-else tooltip="Gestión de la Info." flow="right">
                  <router-link
                    to="/gestion-de-la-informacion"
                    class="menu-button color-azul"
                  >
                    <img
                      class="icon mx-auto"
                      src="@/assets/images/icons/edit.svg"
                    />
                  </router-link>
                </div>
              </div>
              <div v-if="user.core_role_id == 17">
                <div
                  v-if="abrir"
                  :class="[{ 'active item-arrow': hasSubMenu }]"
                  @mouseover="showSubMenu = true"
                  @mouseleave="showSubMenu = false"
                  style="position: relative"
                >
                  <router-link
                    to="/sveManagement"
                    class="menu-button color-azul"
                    @mouseover="showSubMenu = true"
                    @mouseleave="showSubMenu = false"
                  >
                    <img
                      class="img-icon"
                      src="@/assets/images/icons/edit.svg"
                    />
                    <p class="mb-0 ml-4 d-none d-lg-block">
                      Gestión de la Info.
                    </p>
                  </router-link>
                  <ul class="sub-menu" :class="{ active: showSubMenu }">
                    <li>
                      <router-link
                        to="/absenteeism-index"
                        class="menu-button color-azul"
                      >
                        <p class="mb-0 ml-4 d-none d-lg-block">Ausentismos</p>
                      </router-link>
                    </li>
                  </ul>
                </div>
                <div v-else tooltip="Gestión de la Info." flow="right">
                  <router-link
                    to="/sveManagement"
                    class="menu-button color-azul"
                  >
                    <img
                      class="icon mx-auto"
                      src="@/assets/images/icons/edit.svg"
                    />
                  </router-link>
                </div>
              </div>
            </ul>
          </div>
        </template>

        <div v-if="user.core_role_id == 18">
          <div v-if="abrir">
            <router-link to="/uploadFiles" class="menu-button color-azul">
              <span class="icon icon-upload"></span>
              <p class="mb-0 ml-4 d-none d-lg-block">Carga de archivos</p>
            </router-link>
          </div>
          <div v-else tooltip="Carga de archivos" flow="right">
            <router-link to="/uploadFiles" class="menu-button color-azul">
              <span class="icon icon-upload"></span>
            </router-link>
          </div>
        </div>

        <div v-if="user.core_role_id == 18">
          <div v-if="abrir">
            <!-- Se oculta de forma temporal para el rol 2
            <router-link to="/sveManagement" class="menu-button color-azul"
            v-if="user.core_role_id == 18 || user.core_role_id == 2">
            <img class="img-icon" src="@/assets/images/icons/document.svg">
            <p class="mb-0 ml-4 d-none d-lg-block">Informes</p>
          </router-link>
        </div>
        <div v-else tooltip="Informes" flow="right">
          <router-link to="/sveManagement" class="menu-button color-azul"
            v-if="user.core_role_id == 18 || user.core_role_id == 2">
            <img class="icon mx-auto" src="@/assets/images/icons/document.svg">
          </router-link> -->
            <router-link to="/sveManagement" class="menu-button color-azul">
              <img class="img-icon" src="@/assets/images/icons/document.svg" />
              <p class="mb-0 ml-4 d-none d-lg-block">Informes</p>
            </router-link>
          </div>
          <div v-else tooltip="Informes" flow="right">
            <router-link to="/sveManagement" class="menu-button color-azul">
              <img
                class="icon mx-auto"
                src="@/assets/images/icons/document.svg"
              />
            </router-link>
          </div>
        </div>

        <!-- MENU ASIGNADO DE LA CARGA DE FOTOS Y TELEFONOS -->

        <div v-if="abrir">
          <router-link
            to="/uploadPhotos"
            class="menu-button color-azul"
            v-if="user.responsible_upload_photos"
          >
            <img
              class="img-icon"
              style="margin-left: 14px"
              src="@/assets/images/icons/photo.svg"
            />
            <p class="mb-0 ml-4 d-none d-lg-block">Carga de fotografías</p>
          </router-link>
        </div>
        <div v-else tooltip="Carga de fotografías" flow="right">
          <router-link
            to="/uploadPhotos"
            class="menu-button color-azul"
            v-if="user.responsible_upload_photos"
          >
            <img class="icon mx-auto" src="@/assets/images/icons/photo.svg" />
          </router-link>
        </div>

        <!--div v-if="userData.responsible_upload_phones">
          <router-link to="/uploadPhones" class="menu-button">
            <img class="p-0 mx-auto mb-1" src="@/assets/images/icons/phone.svg">
            <p class="mb-0 d-none d-lg-block">Teléfono de contacto</p>
          </router-link>
        </div-->

        <div v-if="abrir">
          <router-link
            to="/uploadPhones"
            class="menu-button color-azul"
            v-if="user.responsible_upload_phones"
          >
            <img
              class="img-icon"
              style="margin-left: 18px"
              src="@/assets/images/icons/phone.svg"
            />
            <p class="mb-0 ml-4 d-none d-lg-block">Teléfono de contacto</p>
          </router-link>
        </div>
        <div v-else tooltip="Teléfono de contacto" flow="right">
          <router-link
            to="/uploadPhones"
            class="menu-button color-azul"
            v-if="user.responsible_upload_photos"
          >
            <img class="icon mx-auto" src="@/assets/images/icons/phone.svg" />
          </router-link>
        </div>

        <!--div>
          <a class="menu-button" href="https://anheuserbuschinbev.sharepoint.com/sites/PeopleparaPeople"
            target="blanck">
            <img class="p-0 mx-auto" src="@/assets/images/icons/Group.svg" width="80%">
          </a>
        </div-->

        <div v-if="abrir">
          <router-link to="/help" class="menu-button help">
            <span class="icon icon-circle-help"></span>
            <p class="mb-0 d-none d-lg-block">Ayuda</p>
          </router-link>
        </div>
        <div v-else tooltip="Ayuda" flow="right">
          <router-link to="/help" class="menu-button help">
            <span class="icon icon-circle-help"></span>
          </router-link>
        </div>
      </div>

      <footer class="w-100 position-absolute d-none d-lg-block">
        <button style="background: transparent; border: 0" @click="open_menu()">
          <img
            v-if="abrir"
            width="100%"
            src="@/assets/images/icons/ocultar_menu.svg"
            alt="Abrir menú"
          />
          <img
            v-else
            src="@/assets/images/icons/open_menu.svg"
            alt="Abrir menú"
          />
        </button>
      </footer>
    </div>
  </div>
  <!-- #main-menu-bar -->
</template>

<script>
import { mapState, mapActions } from "vuex";
import serverConfig from "../../services/config";
import "@/assets/css/general.css";

export default {
  name: "MainBarMenuV2",
  data() {
    return {
      serverPath: serverConfig.permisosURL,
      abrir: false,
      GES: "",
      isSubmenuVisible: false,
      showSubMenu: false,
      hasSubMenu: false,
    };
  },
  beforeMount() {
    if (this.$route.params.ges == "GES") this.GES = "/GES";
    if (localStorage.abrir) {
      this.abrir = localStorage.abrir;
    }

    if (this.user.core_role_id > 10 && this.user.core_role_id < 18)
      this.menucolor_flag = "propinas";
    if (this.user.core_role_id > 17 && this.user.core_role_id < 21)
      this.menucolor_flag = "HT";

    if (this.menucolor_flag == "propinas") {
      this.menucolor = "color naranaja 2";
    } else if (this.menucolor_flag == "HT") {
      this.menucolor = "color azul 2";
    }
  },

  computed: {
    ...mapState("modCore", ["user"]),
  },
  methods: {
    ...mapActions("modCore", ["actUserLocalStorage"]),
    open_menu() {
      this.abrir = !this.abrir;
      localStorage.abrir = this.abrir;
    },
    showSubmenu() {
      this.isSubmenuVisible = true;
    },
    hideSubmenu() {
      this.isSubmenuVisible = false;
    },
    toggleSubMenu() {
      this.hasSubMenu = !this.hasSubMenu;
    },
  },
  mounted() {
    const subMenuElement = this.$el.querySelector(".sub-menu");
    if (subMenuElement && subMenuElement.classList.contains("sub-menu")) {
      this.hasSubMenu = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.menu {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu a {
  display: inline-block;
  position: relative;
}

.menu li a {
  display: block;
  padding: 10px;
  text-decoration: none;
  color: #000;
}

.menu a:hover .sub-menu {
  display: block;
}
.submenu {
  position: relative;
}

.submenu li {
  padding: 0;
}

.submenu p {
  color: black;
}

.submenu:hover ul {
  display: block;
}

.my-tooltip {
  padding-left: 20px;
}
.button-tooltip {
  background-color: #4e6990;
  opacity: 0.8;
}
.btn-secondary {
  border-color: #4e6990 !important;
}
.btn-secondary:hover {
  background-color: #4e6990;
}
.button-tooltip:hover {
  opacity: 1;
}
.btn-lg,
.btn-group-lg > .btn {
  font-family: "Ubuntu";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
}

/* Barra lateral sin abrir main-menu-bar */
.main-menu-bar {
  width: 72px;
  height: calc(100vh);
  //@at-rootborder-radius: 5px;
  display: block !important;
  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  //  width: 100%;
  background-color: #384c69;

  border-radius: 5px 5px 0 0;
  //color: #ffffff;

  //position: fixed;
  z-index: 50;
  bottom: 0;
  left: 0;
  //height: 50px;

  .cont-frist-icon {
    font-size: 20px;
    background-color: #384c69;
    padding: 16px;
    border-bottom: 2px solid #425777;
    border-image: linear-gradient(
      to right,
      rgba(66, 87, 119, 0) 10%,
      rgba(66, 87, 119, 1) 10%,
      rgba(66, 87, 119, 1) 90%,
      rgba(66, 87, 119, 0) 90%
    );
    border-image-slice: 1;
    text-align: left;
  }

  .cont-buttons {
    padding: 0 0px;
    display: flex;
    justify-content: center;
    align-items: center;

    .separator {
      width: 100%;
      height: 1px;
      background-color: #384c69;
    }

    .menu-button {
      color: #ffffff;
      /*display: block;*/
      border-radius: 4px;
      margin-top: 8px;
      margin-left: 5px;
      margin-right: 5px;
      width: 40px;
      height: 40px;

      display: flex;
      align-items: center;

      .icon {
        font-size: 24px;
        margin-left: 3px;
        margin-right: auto;
      }

      p {
        font-size: 24px;
        margin-left: 12px;
        line-height: 16px;
        margin-left: 4px;
        width: -webkit-fill-available;
      }

      &:hover {
        background: linear-gradient(96.63deg, #f96419 -3.39%, #ffd730 103%);

        /* Mid */

        box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
        border-radius: 4px;
        margin-top: 8px;
        margin-bottom: 2px;

        width: 40px;
        height: 40px;
        margin-left: 5px;
        margin-right: 5px;

        display: flex;
        align-items: center;
      }

      @media (min-width: 992px) {
        padding: 15px 5px;
      }
    }

    .router-link-exact-active {
      background: linear-gradient(96.63deg, #f96419 -3.39%, #ffd730 103%);
      /* Mid */
      box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
      border-radius: 4px;
      width: 40px;
      height: 40px;

      display: flex;
      align-items: center;
      margin-top: 8px;
      margin-bottom: 0px;
    }
  }

  footer {
    background: #384c69;
    /* border-radius: 5px;*/
    left: 0;
    bottom: 0;
    padding: 5px 5px;
    border-top: 2px solid #425777;
    border-image: linear-gradient(
      to right,
      rgba(66, 87, 119, 0) 10%,
      rgba(66, 87, 119, 1) 10%,
      rgba(66, 87, 119, 1) 90%,
      rgba(66, 87, 119, 0) 90%
    );
    border-image-slice: 1;
  }

  /*@media (min-width: 992px) {
    width: 86px;
    height: calc(100vh - 30px);
    border-radius: 5px;
    
    position: sticky;
    position: -webkit-sticky;
    top: 0px;
    
  }*/
}

.main_open {
  width: 262px !important;
  height: calc(100vh);
  border-radius: 5px;

  position: sticky;
  position: -webkit-sticky;
  top: 0px;
  //  width: 100%;
  background-color: #384c69;
  border-radius: 5px 5px 0 0;
  color: #ffffff;
  //position: fixed;
  display: block !important;
  z-index: 50;
  bottom: 0;
  left: 0;

  box-shadow: 0px 3px 4px rgba(0, 0, 0, 0.14);

  .cont-frist-icon {
    font-size: 20px;
    background-color: #384c69;
    padding: 16px;
    border-bottom: 2px solid #425777;
    border-image: linear-gradient(
      to right,
      rgba(66, 87, 119, 0) 10%,
      rgba(66, 87, 119, 1) 10%,
      rgba(66, 87, 119, 1) 90%,
      rgba(66, 87, 119, 0) 90%
    );
    border-image-slice: 1;
    text-align: left;
  }

  .cont-buttons {
    padding: 0 0px;
    display: flex;
    justify-content: center;
    align-items: center;

    .separator {
      width: 100%;
      height: 1px;
      background-color: #384c69;
    }
    .menu .sub-menu {
      display: block;
      position: relative;
      top: 100%;
      left: 0;
      padding: 0;
      margin: 5px;
      overflow: hidden;
      height: 0;
      transition: all 0.4s ease;
    }
    .menu .sub-menu.active {
      height: 70px;
    }
    .menu .sub-menu li {
      padding: 10px;
      margin: 5px;
      background-color: #31425b;
      border-radius: 5px;
    }

    .menu .sub-menu .menu-button {
      width: 100% !important;
      padding: 0 0 0 20px;
      margin: 0;
    }
    .item-arrow > .menu-button:after {
      content: "";
      display: block;
      width: 10px;
      height: 10px;
      position: absolute;
      top: 15px;
      right: 15px;
      transform: rotate(45deg);
      transition: all 0.4s ease;
      border-radius: 3px;
      border-bottom: 4px solid #ffffff;
      border-right: 4px solid #ffffff;
    }
    .item-arrow > .menu-button:hover:after {
      transform: rotate(225deg);
      top: 17px;
    }
    .menu-button {
      position: relative;
      color: #ffffff;
      /*display: block;*/
      border-radius: 4px;
      margin-top: 8px;

      width: 246px !important;
      // left: calc(50% - 246px/2) !important;
      height: 40px;

      display: flex;
      align-items: left !important;
      .icon {
        font-size: 24px;
        //margin-left: initial !important;
        margin-left: 14px;
        // margin-right: 0px !important;
      }

      .img-icon {
        margin-left: 12px;
      }

      p {
        /* table header */

        font-family: "Ubuntu";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        /* identical to box height, or 125% */

        display: flex;
        align-items: left !important;
        text-align: left !important;

        margin-right: none !important;

        margin-left: 4px !important;
      }

      &:hover {
        /*@if var($menucolor) == 'propinas' {
          background: linear-gradient(96.63deg, #F96419 -3.39%, #FFD730 103%);
        }
        @else {background: linear-gradient(96.63deg, #395419 -3.39%, #AFD730 103%);}
       */
        background: linear-gradient(96.63deg, #f96419 -3.39%, #ffd730 103%);
        //   background-color: 'green';
        /* Mid */

        box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
        border-radius: 4px;
        margin-top: 8px;
        margin-bottom: 2px;
        width: 40px;
        height: 40px;

        display: flex;
        align-items: center;
      }

      @media (min-width: 992px) {
        padding: 15px 5px;
      }
    }

    .router-link-exact-active {
      background: linear-gradient(96.63deg, #f96419 -3.39%, #ffd730 103%);

      /* Mid */
      box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
      border-radius: 4px;
      width: 40px;
      height: 40px;

      display: flex;
      align-items: center;
      margin-top: 8px;
      margin-bottom: 0px;
    }
  }

  footer {
    background: #384c69;
    /* border-radius: 5px;*/
    left: 0;
    bottom: 0;
    padding: 5px 5px;
    border-top: 2px solid #425777;
    border-image: linear-gradient(
      to right,
      rgba(66, 87, 119, 0) 10%,
      rgba(66, 87, 119, 1) 10%,
      rgba(66, 87, 119, 1) 90%,
      rgba(66, 87, 119, 0) 90%
    );
    border-image-slice: 1;
  }
}

.main-menu-bar .cont-buttons .color-azul:hover {
  background: linear-gradient(
    90deg,
    #00a4ac 10.04%,
    #13ccd6 106.15%
  ) !important;
}

.main-menu-bar .cont-buttons .help:hover {
  background: #4e6991 !important;
}

.main-menu-bar .cont-buttons .router-link-exact-active.color-azul {
  background: linear-gradient(
    90deg,
    #00a4ac 10.04%,
    #13ccd6 106.15%
  ) !important;
}

.main-menu-bar .cont-buttons .router-link-exact-active.help {
  background: #4e6991 !important;
}
</style>
